// extracted by mini-css-extract-plugin
export default {"change-language-wrapper":"change-language-wrapper_RT2hb","radio-group":"radio-group_v1zWA"};